export const i18nextBrowserLanguageDetectionOptions = {
  // ref https://github.com/i18next/i18next-browser-languageDetector
  order: ['localStorage', 'navigator'],

  lookupLocalStorage: 'i18nextLng',

  caches: ['localStorage', 'cookie'],
};
